import { createContext } from "react";
import dayjs from 'dayjs'

const DateContext = createContext({
  date: dayjs().format('YYYY-MM-DD'),
  setDate: (date) => {dayjs(date).format('YYYY-MM-DD')}
});

export default DateContext;